import { useState, useCallback, useEffect } from 'react';
import {
  DEFAULT_LANGUAGE,
  LOCALE_CONFIG,
} from '../context/translations/locales';
import MESSAGES from '../context/translations/messages';
import { parseLanguageParam } from '../context/translations/languageParam';

export const LANGUAGE_STORAGE_KEY = 'language';

export const resolveLanguage = (lang) =>
  lang && LOCALE_CONFIG[lang] ? lang : DEFAULT_LANGUAGE;

// Priority: a valid ?lang= param, then the language saved on an earlier visit,
// then English. Read once, for the very first render, so there is no flash of
// English before the param is applied.
export const getInitialLanguage = (
  search = window.location.search,
  stored = localStorage.getItem(LANGUAGE_STORAGE_KEY)
) => parseLanguageParam(search) || resolveLanguage(stored);

export default function useLanguage() {
  const [language, setLanguage] = useState(() => getInitialLanguage());

  const changeLanguage = useCallback((lang) => {
    setLanguage(resolveLanguage(lang));
  }, []);

  // Single place that persists the resolved language and mirrors it on <html>.
  useEffect(() => {
    const locale = LOCALE_CONFIG[language];
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    document.documentElement.lang = locale.htmlLang;
    document.documentElement.dir = locale.direction;
  }, [language]);

  return {
    language,
    locale: LOCALE_CONFIG[language],
    messages: MESSAGES[language] || MESSAGES[DEFAULT_LANGUAGE],
    changeLanguage,
  };
}
